import { Component, Input, OnChanges, OnInit, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { plainToClass } from 'class-transformer';
import {
  Property, PropertyCategory,
  PropertyCategoryMovementCollection,
  PropertyCategoryMovementService, PropertyForecast, PropertyForecastForm, PropertyService, replace
} from 'taxtank-core';
import { takeUntil } from 'rxjs';
import { BaseFormComponent } from '@shared/component/base/base-form.component';

// @TODO move to core
const MESSAGE_SAVED = 'Forecast saved successfully';

@Component({
  selector: 'app-property-forecast-form',
  templateUrl: './property-forecast-form.component.html',
  styleUrls: ['./property-forecast-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PropertyForecastFormComponent extends BaseFormComponent implements OnInit, OnChanges {
  private categoryMovementService = inject(PropertyCategoryMovementService);
  private propertyService = inject(PropertyService);

  @Input() forecast: PropertyForecast = plainToClass(PropertyForecast, {});
  @Input() property!: Property;
  @Input() isTransparent: boolean;
  @Input() showFinancialYear: boolean;
  @Input() form: PropertyForecastForm;
  @Input() category?: PropertyCategory;
  movements: PropertyCategoryMovementCollection;
  expenseLabel: string;
  interestLabel: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.category) {
      return;
    }

    this.setLabels(this.category);
  }

  ngOnInit(): void {
    if (this.form) {
      return;
    }

    this.categoryMovementService.get().pipe(takeUntil(this.destroy$))
      .subscribe((movements: PropertyCategoryMovementCollection) => {
        this.movements = movements.filterByForecast(this.property, this.forecast);
        super.ngOnInit();
      });
  }

  buildForm(): void {
    if (!this.form) {
      this.form = new PropertyForecastForm(this.forecast, this.movements);
    }

    this.setLabels(this.movements.last.propertyCategory);
  }

  /**
   * Some field labels are depends on property category
   */
  private setLabels(category?: PropertyCategory): void {
    switch (true) {
      case category?.isOwnerOccupied():
        this.expenseLabel = 'Expenses';
        this.interestLabel = 'Interest';
        break;
      case category?.isVacantLand():
        this.expenseLabel = 'Land Expenses';
        this.interestLabel = 'Interest on loans';
        break;
      default:
        this.expenseLabel = 'Rental Expenses';
        this.interestLabel = 'Rental Interest';
    }
  }

  save(forecast: PropertyForecast): void {
    replace(this.property.forecasts, forecast);
    this.propertyService.put(this.property).subscribe(() => {
      this.toastService.success(MESSAGE_SAVED);
      this.saved.emit(forecast);
    });
  }
}
